<!-- 
xs(Extra Small)・・・主にスマホ対応
sm(Small)・・・主にタブレット
md(Medium) ・・・主にノートパソコンや横表示のタブレット
lg(Large)・・・主にデスクトップ
xl(Extra large)・・・4Kや大きなモニター 


v-if="$vuetify.breakpoint.xs"
-->
<template>
    <v-dialog v-if="isView" v-model="isView" persistent width="400">
        <v-card class="mt-3 pa-1">
            <Title title="ライセンス認証">
                <v-spacer />
                <TitleButton
                    color="primary"
                    icon="mdi-close-circle"
                    name="閉じる"
                    @click="isView = false" />
            </Title>
            <v-card-text class="pa-0">
                <v-container fluid>
                    <v-row >
                        <v-col cols="12">
                            <v-text-field
                                v-model="editItems.licenseCode" 
                                dense
                                clearable
                                prepend-icon="mdi-license"
                                label="ライセンスコード"
                                outlined
                                hide-details />
                        </v-col>
                        <v-col cols="12">
                            <v-text-field
                                v-model="editItems.password" 
                                dense
                                clearable
                                prepend-icon="mdi-lock-question"
                                label="パスワード"
                                outlined
                                hide-details />
                        </v-col>
                    </v-row>
                </v-container>
            </v-card-text>
            <v-card-actions>
                <v-spacer />
                <v-slide-x-transition>
                    <v-btn v-if="editItems.licenseCode != '' && editItems.password != ''" class="primary" @click="onClickVerification">認証</v-btn>
                </v-slide-x-transition>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script>
    import db from '@/firebase/firestore.js'
    import Title from '@/components/seedling/items/TitleBar'
    import TitleButton from '@/components/tools/TitleBarButton';
    import jsSHA from "jssha"

    export default {
        components: {
            Title,
            TitleButton
        },
        data: function () {
            return {
                isView: false,
                editItems: {
                    licenseCode: "",
                    password: ""
                },
                /** 結果を受け取るコールバック */
                callback: null
            }
        },
        methods: {
            /**
             * 認証ボタン押下時
             */
            onClickVerification: function () {
                const self = this
                const result = {
                    licenseCode: this.editItems.licenseCode,
                    license: null,
                    result: ""
                }
                const license = db.collection("licenses").doc(this.editItems.licenseCode).get().then(function(doc){
                    if (!doc.exists) {
                        result.result = "ERROR_LICENSE_0001"                        
                    } else {
                        result.license = doc.data()
                        const hashedPassword = self.generateHashedString(self.editItems.password)
                        console.log(self.editItems.password, result.license.password, hashedPassword)
                        if (result.license.password == hashedPassword) {
                            result.result = "LICENSE_OK"
                        } else {
                            result.result = "ERROR_LICENSE_0002"
                        }
                    }
                    if (self.callback != null) {
                        self.callback(result)
                    }
                    self.isView = false
                }).catch (function(error) {
                    self.mi_writeLog("LicenseVerificator/onClickVerification", "ライセンス取得失敗("+self.editItems.licenseCode+")("+error+")")
                })
            },
            /**
             * 指定された文字列をハッシュ化して返す
             */
            generateHashedString: function (text) {
                const sha256 = new jsSHA("SHA-256", "TEXT")
                sha256.update(text)
                return sha256.getHash("HEX")
            },
            /**
             * このダイアログを表示
             */
            show: function (callback) {
                this.callback = callback
                this.editItems.licenseCode = "" // "K7xsnMkfa9Es7mj"
                this.editItems.password = "" // "0jE8aKEp"
                this.isView = true
            }
        }
    }
</script>